import featureFragmentRawString from '../FeatureFragment.graphql'

export const featureFragmentString = featureFragmentRawString

export type FeatureFragment = {
  id: string
  title: string
  subtitle: string
  description: string
}

export const isFeatureFragment = (fragment: any): fragment is FeatureFragment =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.title === 'string' &&
  typeof fragment.subtitle === 'string' &&
  typeof fragment.description === 'string'
